import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ImageViewerWebComponent } from "@shared-ay/image-viewer-web/image-viewer-web.component";
import { IconModule, UiKitModule } from "@jack-sparrow-libraries/ui-kit";

@NgModule({
	declarations: [ImageViewerWebComponent],
	imports: [CommonModule, IconModule, UiKitModule],
	exports: [ImageViewerWebComponent],
})
export class ImageViewerWebModule {}
